import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * QuestionTransition - Smooth question entrance/exit animations
 * Non-breaking wrapper for question cards
 * Preserves all question logic and handlers
 */
const QuestionTransition = ({ children, questionId }) => {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={questionId}
        initial={{ 
          opacity: 0, 
          x: 100,
          filter: 'blur(10px)'
        }}
        animate={{ 
          opacity: 1, 
          x: 0,
          filter: 'blur(0px)'
        }}
        exit={{ 
          opacity: 0, 
          x: -100,
          filter: 'blur(10px)'
        }}
        transition={{ 
          duration: 0.4,
          ease: [0.4, 0, 0.2, 1]
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default QuestionTransition;
